const packageJson = require('../../package.json');

const config = {
    version: packageJson.version,
    debugMode: true,
    isCache: false
};

export default config;